import React, { FC, useContext } from 'react';
import phoneForDark from './phoneForDark.svg';
import phoneForLight from './phoneForLight.svg';
import locationForDark from './locationForDark.svg';
import locationForLight from './locationForLight.svg';
import emailForDark from './emailForDark.svg';
import emailForLight from './emailForLight.svg';
import ContactForm from './ContactForm/ContactForm';
import classes from './ContactFormBlock.module.css';
import { ThemeContext } from '../../../App';

export default function ContactFormBlock() {
  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className="p-10vwrl flex flex-col justify-center">
      <div
        className={
          classes.fieldwork + ' text-center mt-top-vh15 mb-bottom-vh10 '
        }
      >
        <h3 className="uppercase text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH">
          if you have any questions
        </h3>
        <h2 className="uppercase text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH">
          contact us
        </h2>
      </div>
      <div
        className={
          classes.montserrat +
          ' flex flex-col lg:flex-row justify-between w-10/12 mx-auto pb-vh20-top'
        }
      >
        <div className="flex flex-row justify-around lg:justify-start lg:flex-col w-full lg:w-5/12">
          <ItemForContactForm
            imgSrc={theme === 'dark' ? phoneForDark : phoneForLight}
            title="Phone:"
            info="+1 (203) 550-7548"
          />
          <ItemForContactForm
            imgSrc={theme === 'dark' ? locationForDark : locationForLight}
            title="Location:"
            info="114 Morgan Street, Stamford, CT 06905"
          />
          <ItemForContactForm
            imgSrc={theme === 'dark' ? emailForDark : emailForLight}
            title="Email:"
            info="info@fptech-us.com"
          />
        </div>
        <div className="w-full lg:w-5/12 md:mt-top-vh5 lg:mt-0">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

interface ItemForContactFormProps {
  imgSrc: string;
  title: string;
  info: string;
}

const ItemForContactForm: FC<ItemForContactFormProps> = ({
  imgSrc,
  title,
  info,
}) => {
  return (
    <div className="flex flex-col lg:flex-row justify-center lg:justify-start items-center lg:items-start pb-vh3-top w-1/3 lg:w-full px-2">
      <div className="w-vw8 lg:w-vw3 lg:mr-8">
        <img src={imgSrc} alt={title} />
      </div>
      <div className="lg:flex lg:flex-col lg:flex-start lg:items-start text-smAddTxt md:text-mdAdd2Txt lg:text-lg2AddTxt">
        <h5>{title}</h5>
        <p>{info}</p>
      </div>
    </div>
  );
};
